<template>
   <div class="pa-5 pt-5">
        <h2 
            class="d-flex justify-space-between align center mb-1 pl-1 common-text-alignment align-center ml-1 mr-4"
        >
            Build Segments with AI
            <v-btn
                icon
                @click.stop="closeSideBar"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </h2>
        <div 
            class = "subtitle-1-custom mt-4 ml-2 mb-5"
        >
        This feature uses natural language processing to build segments using human readable sentence structure.
        <br/>
        This currently supports a limited set of records - 
       
        <a
            v-track="'NLP-help-center-link'"
            href="https://galaxy.maropost.com/s/article/Segment-Rules-in-Next-Gen-Segment-Builder"
            target="_blank"
        >
            Learn More
        </a></div>
        
        <v-form>
            <v-container
                class="py-2 px-2"
            >
                <!-- <v-row>
                    <v-col cols="12" class="pt-1">
                        <v-expansion-panels
                            v-model="panel"
                            multiple
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header 
                                    expand-icon="mdi-menu-down" 
                                    class="px-3"
                                >
                                    <h4 class=" panel-title secondary--font ">
                                    Segment Name*
                                    </h4>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-text-field
                                        label="Segment Name *"
                                        outlined
                                    />
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row> -->
                <Ai-input ref="aiInputComponent"></Ai-input>
            </v-container>
        </v-form>
    </div>
</template>
<script>
    import AiInput from './AIInput.vue'
    export default {
      name: 'segmentAiDrawer',
      components:{
        AiInput
      },
      data () {
        return {
            panel: false,
        }
      },
      computed:{
        AIgenratedFilters:{
            get(){
                return this.$refs.aiInputComponent ? this.$refs.aiInputComponent.allAifilters : []
            },
            cache:false
        }
      },
      methods: {
        closeSideBar(){
            this.$refs.aiInputComponent.removeCriteriaFromRule()
            this.$store.commit('ui/drawer.right', {
                show:false
            })
        }
        } 
    }
  </script>
  <style lang="scss" scoped>
  .common-text-alignment{
    font-size: 1.25rem;
    letter-spacing: 0.15px;
    line-height: 24px;
  }
  .subtitle-1-custom{
    letter-spacing: 0.5px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.60);
  }
  .v-application a {
    cursor: pointer;
    text-decoration: none;
  }
  </style>